import Socium from '../constants/Socium';
import Cookies from 'universal-cookie';

export const resetTokenFromCookie = () => {
  const cookies = new Cookies();
  cookies.remove(Socium.COOKIE_TOKEN, {
    path: '/'
  });
};

export const setCookieToken = token => {
  const cookies = new Cookies();
  cookies.set(Socium.COOKIE_TOKEN, token, {
    path: '/'
  });
};

export const getTokenFromCookie = () => {
  const cookies = new Cookies();
  return cookies.get(Socium.COOKIE_TOKEN) || '';
};
